import React, { useEffect, useState } from "react";
import { YardDateField } from "../../../components/common/YardDateField";
import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import {
  Box,
  Card,
  Divider,
  makeStyles,
  Tab,
  Tabs,
  useMediaQuery,
} from "@material-ui/core";
import classnames from "classnames";

import {
  BulkActionsToolbar,
  CreateButton,
  Datagrid,
  DateInput,
  downloadCSV,
  EditButton,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  RefreshButton,
  SimpleList,
  ShowButton,
  TextField,
  Title,
  TopToolbar,
  useListContext,
  FunctionField,
} from "react-admin";

import { ChevronRightIcon } from "../../../components/common/iconography";
import { Empty } from "../../../components/common/Empty";
import ExportButton from "../../../components/common/ExportButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { SearchField } from "../../../components/common/SearchField";
import { useSearchableList } from "../../../dataProvider/useSearchableList";
import { isAuthorized } from "../../../utils/appUtils";
import { AclType, OutboundStatus } from "../../../utils/constants";
import { exportCustomField, normalizeValue } from "../../../utils/utils";
import { useUser } from "../../../authenticatorApp/UserContext";
import { BetaBadge } from "../../../components/common/FeatureBadges";
import { AdviceStatusIcon } from "./AdviceStatusIcon";
import ShipsTogetherBadge from "../../../components/common/shipWith/ShipsTogetherBadge";
import ShipsTogetherButton from "../../../components/common/shipWith/ShipsTogetherButton";
import useShipWithSelection from "../../../components/common/shipWith/useShipWithSelection";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  bulkActions: {
    // Same as the manager list: pull the card up under the bulk toolbar.
    marginTop: -theme.spacing(8),
    transition: theme.transitions.create("margin-top"),
  },
}));

const tabs = [
  {
    id: OutboundStatus.ADVICE_ALL,
    name: (
      <span>
        Advices <BetaBadge />
      </span>
    ),
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: false,
  },
  {
    id: OutboundStatus.PENDING,
    name: "Pending",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.ARRIVED,
    name: "Arrived",
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: false,
  },
  {
    id: OutboundStatus.PLACED,
    name: "Placed",
    // placementDateTime is not in the by-dates GSI; arrivalDateTime is, and
    // placing backfills it when unset, so it approximates placed order.
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.LOADED,
    name: "Loaded",
    sortKey: "endDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.RELEASED,
    name: "Released",
    sortKey: "endDateTime",
    sortOrder: "DESC",
    showSmall: false,
  },
];

const getVisibleTabs = (lteMedium, appUser) => {
  return tabs.filter(
    (tab) => isTabEnabled(tab.id, appUser) && (!lteMedium || tab.showSmall),
  );
};

const isAdviceEnabled = (appUser) => {
  return (
    isAuthorized(AclType.OUTBOUND_ADVICE) &&
    appUser?.account?.outboundAdviceInputs?.length > 0
  );
};

const isTabEnabled = (tabId, appUser) => {
  if (tabId === OutboundStatus.ADVICE_ALL) return isAdviceEnabled(appUser);
  return true;
};

/**
 * Linking lives on the Advices and Pending tabs only (AD-8). ADVICE_ALL is a
 * prefix over ADVICE_, so its grid can hold rejected advices; the button
 * refuses those client-side and the lambda refuses them regardless.
 */
export const isShipsTogetherTab = (tabId) =>
  tabId === OutboundStatus.ADVICE_ALL || tabId === OutboundStatus.PENDING;

export const BulkListActions = ({ tabValue, ...props }) =>
  isShipsTogetherTab(tabValue) ? <ShipsTogetherButton {...props} /> : null;

const getRowClickAction = (record) => {
  switch (record.status) {
    case OutboundStatus.ADVICE_PENDING:
      return "show";
    case OutboundStatus.ADVICE_REJECTED:
      return "edit";
    default:
      return "show"; // Default action if status does not match any case
  }
};

const renderActionButtons = (record) => {
  if (record.status === "ADVICE_REJECTED") {
    return <EditButton record={record} />;
  } else {
    return <ShowButton record={record} />;
  }
};

const exporter = (outbounds) => {
  const customHeaderMap = new Map();
  debugger;
  const outboundsForExport = outbounds.map((outbound) => {
    const outboundForExport = { ...outbound };

    if (outbound.shipmentLineItems.items) {
      outboundForExport.pickList = [];

      outbound.shipmentLineItems.items.forEach((lineItem) => {
        lineItem.inventoryItems.items.forEach((inventoryItem) => {
          const exportlineItem = {
            inventoryId: lineItem.inventoryId,
            productCode: lineItem.inventory.productCode,
            productName: lineItem.inventory.productName,
            lotNumber: lineItem.lotNumber,
            quantityOutbound: lineItem.totalQuantityToPick,
            units: outbound.totalUOM,
            location: inventoryItem.inventoryItem.locationFullName,
            quantityOnHand: inventoryItem.inventoryItem.quantityOnHand,
          };

          outboundForExport.pickList.push(exportlineItem);
        });
      });
    }
    delete outboundForExport.shipmentLineItems;

    if (outbound.customFields?.length > 0) {
      debugger;
      outbound.customFields.forEach((field) => {
        exportCustomField(field, outboundForExport, customHeaderMap);
      });
    }
    delete outboundForExport.customFields;

    delete outboundForExport.account;
    delete outboundForExport.assignedTo;
    delete outboundForExport.bolFile;
    delete outboundForExport.createdAt;
    delete outboundForExport.createDateTime;
    delete outboundForExport.daysOnDemurrageClock;
    delete outboundForExport.didTarp;
    delete outboundForExport.endDateTime;
    delete outboundForExport.history;
    delete outboundForExport.invoiceId;
    delete outboundForExport.mustTarp;
    delete outboundForExport.reloadYardId;
    delete outboundForExport.startDateTime;
    delete outboundForExport.updatedAt;

    return outboundForExport;
  });

  jsonExport(
    fillDownRows(outboundsForExport),
    { rename: ["outboundShipmentId"] },
    (err, csv) => {
      downloadCSV(csv, `outboundShipments_${new Date().toLocaleDateString()}`); // download as 'outboundShipments.csv` file
    },
  );
};

const OutboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const normalizedValue = normalizeValue(value);
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { carrierName: { matchPhrasePrefix: `${value}` } },
            { bolNumber: { matchPhrasePrefix: `${value}` } },
            { bolNumber: { wildcard: `*${value}*` } },
            // {
            //   normalizedPickupNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // {
            //   normalizedConsigneePoNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            { normalizedPickupNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            {
              normalizedConsigneePoNumber: { wildcard: `*${normalizedValue}*` },
            },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (visibleTabs, tabIndex) => {
  const filters = [<OutboundSearchField label="Search" alwaysOn />];

  if (visibleTabs[tabIndex].id === OutboundStatus.RELEASED) {
    filters.push(
      <DateInput
        source="departureDateTime.lte"
        label="Shipped Before..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
      <DateInput
        source="departureDateTime.gte"
        label="Shipped After..."
        variant="outlined"
        resettable
        onKeyPress={(event) => event.preventDefault()}
      />,
    );
  }
  return filters;
};

const ListActions = (props) => {
  const { appUser, isXSmall } = props;
  const { resource, total } = useListContext();

  return !isXSmall ? (
    <TopToolbar>
      <FilterButton />
      {isAdviceEnabled(appUser) && <CreateButton />}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        exporter={exporter}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSortOrder = (visibleTabs, tabIndex) => {
  return visibleTabs[tabIndex].sortOrder;
};

const getSortBy = (visibleTabs, tabValue) => {
  const tabIndex = visibleTabs.findIndex((tab) => tab.id === tabValue);
  return `{"key":"outboundShipmentByAccountByStatusByDates", "search":"${visibleTabs[tabIndex].sortKey}"}`;
};

const getSessionTab = (visibleTabs, appUser) => {
  const sessionTab = Number(
    sessionStorage.getItem(`OutboundTab_${appUser.id}`),
  );
  if (sessionTab && visibleTabs[sessionTab]) {
    return sessionTab;
  }
  return 0; // Default to the first visible tab if the sessionTab is not valid
};

export const OutboundList = (props) => {
  const { appUser } = useUser();
  const classes = useStyles();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const lteMedium = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [visibleTabs, setVisibleTabs] = useState(
    getVisibleTabs(lteMedium, appUser),
  );
  const [tabIndex, setTabIndex] = useState(getSessionTab(visibleTabs, appUser));

  const [defaultFilter, setDefaultFilter] = useState({
    accountId: appUser.accountId,
    statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: {
      beginsWith: {
        status: visibleTabs[tabIndex].id,
      },
    },
  });
  const [defaultSearchFilter, setDefaultSearchFilter] = useState({
    reloadYardId: { eq: appUser?.reloadYardId },
    accountId: { eq: appUser.accountId },
    status: { matchPhrasePrefix: visibleTabs[tabIndex].id },
  });
  const defaultSort = {
    field: getSortBy(visibleTabs, visibleTabs[tabIndex].id),
    order: getSortOrder(visibleTabs, tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Outbound",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "outboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  useEffect(() => {
    setVisibleTabs(getVisibleTabs(lteMedium, appUser));
  }, [lteMedium, appUser]);

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    // A selection made on Pending must not carry into Advices.
    listContext.onUnselectItems?.();
    setDefaultFilter({
      accountId: appUser.accountId,
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime: {
        beginsWith: {
          status: visibleTabs[value].id,
        },
      },
    });
    setDefaultSearchFilter({
      reloadYardId: { eq: appUser?.reloadYardId },
      accountId: { eq: appUser.accountId },
      status: { eq: visibleTabs[value].id },
    });
    listContext.setSort(
      getSortBy(visibleTabs, visibleTabs[value].id),
      getSortOrder(visibleTabs, value),
    );
    listContext.setPage(1);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Outbound" />} />
      <ListToolbar
        {...props}
        filters={getListFilters(visibleTabs, tabIndex)}
        actions={<ListActions appUser={appUser} isXSmall={isXSmall} />}
      />
      <Card
        className={classnames(classes.listRoot, {
          [classes.bulkActions]: listContext.selectedIds?.length > 0,
        })}
      >
        <BulkActionsToolbar>
          <BulkListActions tabValue={visibleTabs[tabIndex].id} />
        </BulkActionsToolbar>
        <ShipmentTabs
          {...props}
          {...listContext}
          appUser={appUser}
          visibleTabs={visibleTabs}
          tabIndex={tabIndex}
          setTabIndex={handleTabChange}
          isXSmall={isXSmall}
          lteMedium={lteMedium}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({ tabIndex, setTabIndex, setPage, ...props }) => {
  const { visibleTabs, appUser } = props;

  const handleChange = (event, value) => {
    const adjustedValue = visibleTabs[value] ? value : 0; // Adjust tab index to the first visible tab if needed
    sessionStorage.setItem(`OutboundTab_${appUser.id}`, adjustedValue);
    setTabIndex(adjustedValue);
  };

  return (
    <>
      <Tabs
        value={Number(tabIndex)}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {visibleTabs.map((tab, idx) => (
          <Tab key={tab.id} label={tab.name} id={`shipment-${idx}`} />
        ))}
      </Tabs>
      <Divider />
      {visibleTabs.map(
        (tab) =>
          tab.id === visibleTabs[tabIndex].id && (
            <ShipmentGrid {...props} key={tab.id} tabValue={tab.id} />
          ),
      )}
    </>
  );
};

export const ShipmentGrid = ({ ids, page, visibleTabs, tabValue, ...props }) => {
  const { isXSmall, lteMedium } = props;
  // A ships-together group cannot cross accounts, so once one load is picked
  // the other accounts' rows lose their checkbox.
  const isRowSelectable = useShipWithSelection(isShipsTogetherTab(tabValue));

  if (tabValue === OutboundStatus.ADVICE_ALL && ids.length === 0 && page === 1)
    return <Empty {...props} message="Create outbound advice" />;
  return isXSmall ? (
    <SimpleList
      linkType={(record) => getRowClickAction(record)}
      primaryText={(record) => record.accountName}
      secondaryText={(record) => `Pickup No: ${record.pickupNumber}`}
      tertiaryText={(record) => `PO #: ${record.poNumber}`}
      leftIcon={(record) => (
        <Box display="flex" alignItems="center">
          <ShipsTogetherBadge record={record} selfId={record.id} compact />
        </Box>
      )}
      rightIcon={() => (
        <ChevronRightIcon
          fontSize="large"
          color="secondary"
          style={{ marginLeft: 40, marginTop: 10 }}
        />
      )}
    />
  ) : lteMedium ? (
    <Datagrid
      rowClick={(jsonRecord, basePath, record) => getRowClickAction(record)}
      hasBulkActions={isShipsTogetherTab(tabValue)}
      isRowSelectable={isRowSelectable}
    >
      <FunctionField
        source="shipWithIds"
        label=" "
        sortable={false}
        render={(record) => (
          <ShipsTogetherBadge record={record} selfId={record.id} size="small" />
        )}
      />
      <TextField source="poNumber" label="PO Number" sortable={true} />
      <TextField source="pickupNumber" label="Pickup No." sortable={true} />
      <TextField source="carrierName" label="Carrier Name" sortable={true} />
      {tabValue === OutboundStatus.ADVICE_ALL ||
      tabValue === OutboundStatus.PENDING ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.ARRIVED ? (
        <YardDateField
          source="arrivalDateTime"
          label="Arrival Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.PLACED ? (
        <YardDateField
          source="placementDateTime"
          fallbackSource="arrivalDateTime"
          label="Placed Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.LOADED ? (
        <YardDateField
          source="endDateTime"
          label="Loaded Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <YardDateField
          source="departureDateTime"
          label="Ship Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
    </Datagrid>
  ) : (
    <Datagrid
      rowClick={(jsonRecord, basePath, record) => getRowClickAction(record)}
      hasBulkActions={isShipsTogetherTab(tabValue)}
      isRowSelectable={isRowSelectable}
    >
      <FunctionField
        source="shipWithIds"
        label=" "
        sortable={false}
        render={(record) => (
          <ShipsTogetherBadge record={record} selfId={record.id} size="small" />
        )}
      />
      {tabValue === OutboundStatus.ADVICE_ALL ? <AdviceStatusIcon /> : null}
      <TextField source="poNumber" label="PO Number" sortable={true} />
      <TextField source="pickupNumber" label="Pickup No." sortable={true} />
      <TextField source="carrierName" label="Carrier Name" sortable={true} />
      {tabValue === OutboundStatus.ADVICE_ALL ||
      tabValue === OutboundStatus.PENDING ? (
        <YardDateField
          source="scheduledDateTime"
          label="Scheduled Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.ARRIVED ? (
        <YardDateField
          source="arrivalDateTime"
          label="Arrival Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.PLACED ? (
        <YardDateField
          source="placementDateTime"
          fallbackSource="arrivalDateTime"
          label="Placed Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.LOADED ? (
        <YardDateField
          source="endDateTime"
          label="Loaded Time"
          showTime={true}
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <YardDateField
          source="departureDateTime"
          label="Ship Date"
          sortable={true}
          sortBy={getSortBy(visibleTabs, tabValue)}
        />
      ) : null}
      {tabValue === OutboundStatus.RELEASED ? (
        <TextField source="bolNumber" label="BOL Number" sortable={true} />
      ) : null}
      <FunctionField render={(record) => renderActionButtons(record)} />
    </Datagrid>
  );
};
